import React from "react";
import { Modal, Box } from "@mui/material";
import Contract from "./contract";
import type { ContractProps } from "./contract";

interface ContractModalProps extends ContractProps {
  open: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "white",
  border: "none",
  boxShadow: 24,
  outline: "none",
  borderRadius: "6px",
  p: 4,
};

const ContractModal: React.FC<ContractModalProps> = ({
  open,
  setModalOpen,
  fullName,
  cpf,
  address,
  email,
  phoneNumber,
  marritalStatus,
  associateQuantity,
  membershipPrice,
  pricePerAssociate,
  startDate,
  renewalDate,
  priceReadjustment,
  birthDate,
}) => {
  return (
    <Modal
      open={open}
      onClose={() => setModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="contract-modal" sx={style}>
        <Contract
          fullName={fullName}
          cpf={cpf}
          address={address}
          email={email}
          phoneNumber={phoneNumber}
          marritalStatus={marritalStatus}
          associateQuantity={associateQuantity}
          membershipPrice={membershipPrice}
          pricePerAssociate={pricePerAssociate}
          startDate={startDate}
          renewalDate={renewalDate}
          priceReadjustment={priceReadjustment}
          birthDate={birthDate}
        />
      </Box>
    </Modal>
  );
};

export default ContractModal;
